'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Pressable, { PressableProps } from '@components/kit/pressable'
import Text from '@components/kit/text'

/* -----------------------------------------------------------------------------
 * FilterPill
 * -------------------------------------------------------------------------- */

export type FilterPillProps = PressableProps & {
  label: string
  selected?: boolean
}

function FilterPill({ label, selected = false, ...otherProps }: FilterPillProps) {
  return (
    <Pressable
      bg={selected ? 'proInk' : 'proSurface'}
      borderColor={selected ? 'proInk' : 'proBorder'}
      borderRadius='proPill'
      borderStyle='solid'
      borderWidth={1}
      px='16'
      py='08'
      {...otherProps}
    >
      <Text
        font='pro.text.12.semibold'
        textColor={selected ? 'white' : 'proTextBody'}
      >
        {label}
      </Text>
    </Pressable>
  )
}

export default FilterPill
